export const useCamtekMetadata = (dataset: any) => {
  const getCamtekMetadata = (name: string) => {
    const value = dataset.metadata?.camtek_db_export?.[name];
    return !value
      ? null
      : Array.isArray(value)
        ? value.map((v) => `"${v}"`).join(", ")
        : value;
  };

  const hasJobSetupRecipeMetadata =
    getCamtekMetadata("Job Name") ||
    getCamtekMetadata("Setup Name") ||
    getCamtekMetadata("Recipes Name");

  return {
    getCamtekMetadata,
    hasJobSetupRecipeMetadata,
  };
};
